import { closeModal } from "./actionCreators"

export const mapState = (state) => ({
  modalIsOpen: state.modalReducer.modalIsOpen,
  modalContents: state.modalReducer.modalContents,
  hideCloseIcon: state.modalReducer.hideCloseIcon,
  shouldCloseOnOverlayClick: state.modalReducer.shouldCloseOnOverlayClick,
})

export const mapDispatch = (dispatch) => ({
  closeModal: () => dispatch(closeModal()),
})
